module.exports = __webpack_public_path__ + "img/38_47.5323b571.png";